import { Shield, Globe, CheckCircle } from "lucide-react";

export const SEOSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#FAFAF9] relative"
      data-testid="seo-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-14">
            <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
              Our Commitment
            </span>
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-[#1A1A1A] mt-4 md:mt-6 leading-tight">
              Protecting Property Investments for
              <span className="block text-[#C5A028] italic">Nigerians at Home and Abroad</span>
            </h2>
            <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8" />
          </div>

          {/* Content */}
          <div className="space-y-5 md:space-y-6 text-[#1A1A1A]/60 text-sm md:text-base lg:text-lg leading-[1.8] md:leading-[1.9] text-center max-w-3xl mx-auto">
            <p>
              Nigeria's property market presents significant opportunities — but also risks for 
              investors without proper legal guidance.
            </p>
            <p>
              4 ACES Attorneys provides strategic legal counsel to help clients verify property 
              titles, conduct thorough due diligence, and structure secure acquisitions.
            </p>
            <p>
              We regularly advise investors in Nigeria, the United Kingdom, the United States, 
              Canada, and the UAE seeking clarity and protection when purchasing property in Nigeria.
            </p>
          </div>

          {/* Location badges */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-10 md:mt-14">
            {["Nigeria", "United Kingdom", "United States", "Canada", "UAE"].map((location) => (
              <div 
                key={location}
                className="flex items-center gap-2 border border-[#D4AF37]/30 px-4 py-2 md:px-5 md:py-2.5"
              >
                <Globe className="w-3 h-3 md:w-4 md:h-4 text-[#D4AF37]" />
                <span className="text-[#1A1A1A]/70 text-xs md:text-sm">{location}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
